/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QueryRequest
 */
export interface QueryRequest {
    /**
     * 
     * @type {string}
     * @memberof QueryRequest
     */
    query: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueryRequest
     */
    ids: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof QueryRequest
     */
    pageNumber: string;
    /**
     * 
     * @type {number}
     * @memberof QueryRequest
     */
    n: number;
}

/**
 * Check if a given object implements the QueryRequest interface.
 */
export function instanceOfQueryRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "query" in value;
    isInstance = isInstance && "ids" in value;
    isInstance = isInstance && "pageNumber" in value;
    isInstance = isInstance && "n" in value;

    return isInstance;
}

export function QueryRequestFromJSON(json: any): QueryRequest {
    return QueryRequestFromJSONTyped(json, false);
}

export function QueryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): QueryRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'query': json['query'],
        'ids': json['ids'],
        'pageNumber': json['pageNumber'],
        'n': json['n'],
    };
}

export function QueryRequestToJSON(value?: QueryRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'query': value.query,
        'ids': value.ids,
        'pageNumber': value.pageNumber,
        'n': value.n,
    };
}

